import HttpFactory from '~/repository/factory';

class UserModule extends HttpFactory {
  private RESOURCE = '/users';

  async list() {
    return this.get(this.RESOURCE);
  }

  async getById(id: string) {
    return this.get(`${this.RESOURCE}/${id}`);
  }

  async create(data: {
    cpf: string;
    name: string;
    email: string;
    pdv: number;
    role: string;
  }) {
    return this.post(this.RESOURCE, data);
  }

  async update(
    id: string,
    data: {
      name?: string;
      email?: string;
      pdv?: number;
      role?: string;
    },
  ) {
    return this.put(`${this.RESOURCE}/${id}`, data);
  }

  async toggleState(id: string) {
    return this.patch(`${this.RESOURCE}/${id}/toggle-state`);
  }

  async remove(id: string) {
    return this.delete(`${this.RESOURCE}/${id}`);
  }

  async resetPassword(id: string, password?: string) {
    return this.post(`${this.RESOURCE}/${id}/reset-password`, password ? { password } : undefined);
  }
}

export default UserModule;
